import { z } from "zod";

/* =========================
   STRING
========================= */
export const stringSchema = z.string().trim().min(1, "Ce champ est requis");

export const optionalStringSchema = z.string().trim().optional();

/* =========================
   PASSWORD
========================= */
export const passwordSchema = z
  .string()
  .min(6, "Le mot de passe doit avoir au moins 6 caractères")
  .max(20, "Le nouveau mot de passe doit avoir au maximum 20 caractères")
  .regex(
    /[A-Z]/,
    "Le nouveau mot de passe doit contenir au moins une lettre majuscule",
  )
  .regex(
    /[!@#$%^&*(),.?":{}|<>_\-\\[\]/+=~`;'']/,
    "Le mot de passe doit contenir au moins un caractère spécial",
  );
/* =========================
   EMAIL
========================= */

export const emailSchema = z
  .email("Adresse email invalide")
  .trim()
  .min(1, "Email requis");

// export const optionalEmailSchema = z.preprocess((value) => {
//   if (typeof value === "string" && value.trim() === "") {
//     return undefined;
//   }

//   return value;
// }, z.email("Adresse email invalide").trim().optional());

export const optionalEmailSchema = z.preprocess(
  (value) => value ?? "",
  z
    .string()
    .trim()
    .pipe(
      z.union([z.literal(""), z.string().email("Adresse e-mail invalide")]),
    ),
);

/* =========================
   PHONE
========================= */

const phoneRdcRegex = /^(?:\+243|243|0)?(?:8[0-9]|9[0-9])\d{7}$/;
export const phoneSchema = z
  .string()
  .trim()
  .min(1, "Numéro de téléphone requis")
  .regex(phoneRdcRegex, "Numéro de téléphone invalide");

export const optionalPhoneSchema = z.preprocess((value) => {
  if (typeof value === "string" && value.trim() === "") {
    return undefined;
  }

  return value;
}, z.string().trim().regex(phoneRdcRegex, "Numéro de téléphone invalide").optional());

/* =========================
   AMOUNT
========================= */

export const amountSchema = z.coerce
  .number({
    message: "Le montant doit être un nombre",
  })
  .positive("Le montant doit être supérieur à 0");

export const optionalAmountSchema = z.preprocess((value) => {
  if (typeof value === "string" && value.trim() === "") {
    return undefined;
  }

  return value;
}, amountSchema.optional());

// minimum 5 ans
export const birthDateSchema = z.coerce.date().refine(
  (date) => {
    const today = new Date();
    const minDate = new Date(
      today.getFullYear() - 5,
      today.getMonth(),
      today.getDate(),
    );

    return date <= minDate;
  },
  {
    message: "L'âge minimum requis est de 5 ans",
  },
);
